import EmailInput from '../../../FormElements/EmailInput';

import type { Control } from 'react-hook-form';
import type { EmailCollectionFormData } from '../../types';

function NewEmailView({
  descriptionText,
  formControl,
}: {
  descriptionText?: string;
  formControl: Control<EmailCollectionFormData>;
}) {
  return (
    <>
      <div className="bp-font-primary bp-text-base bp-font-normal bp-leading-primary bp-text-gray-900">
        {descriptionText}
      </div>

      <div className="bp-w-full">
        <EmailInput className="bp-w-full bp-bg-white" control={formControl} required />
      </div>
    </>
  );
}

export default NewEmailView;
